import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbAccordionModule,
  NbActionsModule,
  NbAlertModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule, NbCheckboxModule,
  NbContextMenuModule, NbDatepickerModule, NbIconModule,
  NbInputModule,
  NbLayoutModule, NbPopoverModule, NbSearchModule, NbSelectModule,
  NbSidebarModule, NbSpinnerModule, NbStepperModule, NbTabsetModule, NbTimepickerModule, NbToggleModule, NbTooltipModule
} from "@nebular/theme";
import {AgGridModule} from "ag-grid-angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxCurrencyModule} from "ngx-currency";
import {NgxMaskModule} from "ngx-mask";
import {customCurrencyMaskConfig} from "@app/config/currency-mask-config";
import {TooltipModule} from "ng2-tooltip-directive";
import {DefaultTooltipOptions} from "@app/config/tooltip-config";
import { TooltipOptions } from 'ng2-tooltip-directive';
import {MatRippleModule} from "@angular/material/core";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {SafePipeModule} from "safe-pipe";
import {GooglePlaceModule} from "ngx-google-places-autocomplete";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgxMatTimelineModule} from "ngx-mat-timeline";
import {NgxDropzoneModule} from "ngx-dropzone";
import {MatSidenavModule} from "@angular/material/sidenav";
import {NgxPaginationModule} from "ngx-pagination";
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import {AngularSignaturePadModule} from "@almothafar/angular-signature-pad";
import {NgxSliderModule} from "@angular-slider/ngx-slider";


@NgModule({
  declarations: [
    SignaturePadComponent
  ],
  imports: [
    CommonModule , NbCardModule, NbLayoutModule,
    AgGridModule,NbSidebarModule,NbContextMenuModule,NbSelectModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),  NgxMaskModule.forRoot(),
    NbBadgeModule, NbIconModule,FormsModule,ReactiveFormsModule,NbAlertModule,
    NbSearchModule,NbTooltipModule,
    TooltipModule.forRoot(DefaultTooltipOptions as TooltipOptions),
    NbPopoverModule,NbActionsModule,MatRippleModule,NbInputModule,
    PdfViewerModule,SafePipeModule,NbToggleModule,NbSpinnerModule,NbTabsetModule,
    GooglePlaceModule,NbDatepickerModule.forRoot(), NbTimepickerModule.forRoot(), FontAwesomeModule,
    NgxMatTimelineModule,NbCardModule,NbStepperModule,NgxDropzoneModule,MatSidenavModule,NbCheckboxModule,
    NbAccordionModule,NgxPaginationModule,AngularSignaturePadModule,




  ],
  exports :[
    CommonModule , NbCardModule, NbLayoutModule, AgGridModule, ReactiveFormsModule,
    NbSidebarModule,NbContextMenuModule,NbSelectModule,NgxCurrencyModule, NbIconModule,
    NbSearchModule,NbTooltipModule,
    NgxMaskModule,NbBadgeModule,
    NbButtonModule, FormsModule,NbAlertModule,TooltipModule,NbPopoverModule,
    NbActionsModule,MatRippleModule,NbInputModule,PdfViewerModule,
    SafePipeModule,NbToggleModule,NbSpinnerModule,NbTabsetModule,GooglePlaceModule,
    NbDatepickerModule,NbTimepickerModule, FontAwesomeModule,
    NgxMatTimelineModule,NbCardModule,NbStepperModule,NbCheckboxModule,
    NgxDropzoneModule,MatSidenavModule,NbAccordionModule,
    NgxPaginationModule,SignaturePadComponent,AngularSignaturePadModule,


  ],


})
export class SharedModule { }
